<template>
    <v-row>
        <v-col v-if="mobile && selectedItem !== null" cols="12">
            <button class="btn-back" :class="{'custom-pink': switchMe, 'custom-blue': !switchMe}" @click="selectedItem = null">
                <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 1L1.70711 5.29289C1.31658 5.68342 1.31658 6.31658 1.70711 6.70711L6 11" :stroke="switchMe ? '#ffa3e0' : '#1876D2'" stroke-width="2" stroke-linecap="round"></path>
                </svg>
                Назад
            </button>
        </v-col>
        <v-col v-if="!mobile || selectedItem !== null" cols="8" sm="9" md="10" class="pb-0" :class="!mobile ? 'mt-10' : 'mt-8'">
            <v-slider
                class="slider-age"
                :min="1"
                :max="18"
                v-model="ageOnMonth"
                step="1"
                thumb-label="always"
                :thumb-size="34"
                :color="switchMe ? '#ffa3e0' : 'primary'"
                :track-color="switchMe ? '#ffa3e0' : 'primary'"
            >
                <template v-slot:prepend>
                    Возраст 
                </template>
            </v-slider>
        </v-col>
        <v-col v-if="!mobile || selectedItem !== null" cols="4" sm="3" md="2" class="pb-0" :class="!mobile ? 'mt-10' : 'mt-8'">
            <v-row>
                <v-col cols="auto" sm="auto" md="auto">
                    <span :class="{'fs-16':true}">М</span>
                </v-col>
                <v-col cols="auto" sm="auto" md="auto" class="pl-0 pr-0">
                    <v-switch :class="{'custom-pink': switchMe, 'custom-blue': !switchMe}" class="pt-0 mt-0" hide-details v-model="switchMe" />
                </v-col>
                <v-col cols="auto" sm="auto" md="auto" class="pl-0">
                    <span :class="{'fs-16':true}">Ж</span>
                </v-col>
            </v-row>
        </v-col>

        <v-col v-if="!mobile || selectedItem === null" cols="12" md="5" :style="`max-height: ${clientH - (!mobile ? 200 : 148)}px; overflow: auto;`">
            <v-list class="py-0" shaped>
                <v-list-item-group v-model="selectedItem" :color="switchMe ? '#ffa3e0' : 'primary'">
                    <v-list-item v-for="(item, i) in items" :key="i" @click="tapList(item, i)">
                        <v-list-item-icon>
                            <v-avatar size="25" tile>
                                <v-img v-if="item.iconUrl" :src="`${apiImg+item.iconUrl}`" contain />
                                <span v-else>
                                    <v-icon class="colorIcon" v-if="item.name == 'Лабораторные исследования'">mdi-test-tube</v-icon>
                                    <v-icon class="colorIcon" v-else>mdi-ruler</v-icon>
                                </span>
                            </v-avatar>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title v-if="item.propertyGroups.length == 0" style="color: rgb(0 0 0 / 26%)"> {{ item.name }} </v-list-item-title>
                            <v-list-item-title v-else> {{ item.name }} </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-item-group>
            </v-list>
        </v-col>

        <v-divider v-if="!mobile" vertical></v-divider>

        <v-col v-if="!mobile || selectedItem !== null" cols="12" md="7">
            <v-card-text class="py-0 my-0">
                <div v-if="dataIsNotFilled()" key="title" class="text-h6 font-weight-light grey--text p-0 m-0 text-center" >
                    <span v-if="active.length === 0">Выберите систему показателей...</span>
                    <span v-if="active.length > 0 && active[0].propertyGroups.length == 0">Данные не заполнены...</span>
                </div>
                
                <div v-else>
                    <v-scroll-x-transition group hide-on-leave>
                        <v-card class="mx-auto" flat :key="active[0].id">

                            <v-row>
                                <v-col cols="12" md="8" :style="`max-height: ${clientH - (!mobile ? 200 : 292)}px; overflow: auto;`">
                                    <v-row
                                        class="p-0 m-0"
                                        tag="v-card-text"
                                        v-for="(selection, i) in filterProperties(active[0].propertyGroups, ageOnMonth*12)"
                                        :key="'A'+i"
                                    >
                                        <v-col cols="12">
                                            <b v-if="Object.entries(filterProperties(active[0].propertyGroups, ageOnMonth*12)).length > 1" style="font-size:19px">
                                                {{ i }}
                                            </b>
                                            <ul>
                                                <li v-for="(item, key) in selection" :key="'A'+key">
                                                    {{ item.name }}, {{ item.value }}
                                                </li>
                                            </ul>
                                        </v-col>
                                    </v-row>
                                </v-col>

                                <v-col v-if="!mobile" cols="12" md="4" align-self="center">
                                    <v-card-text class="py-0 my-0 text-center">
                                        <humanImage
                                            :ageOnMonth="ageOnMonth"
                                            :gender="switchMe"
                                            :activeName="activeName"
                                            :dialogSomaticName="dialogSomaticName"
                                            :heightOffset="386"
                                        />
                                    </v-card-text>
                                </v-col>
                            </v-row>
                        </v-card>

                    </v-scroll-x-transition>
                </div>
            </v-card-text>
        </v-col>
    </v-row>
</template>

<script>
import humanImage from "./HumanImage.vue";

export default {
    components: { humanImage },
    props: {
        humanInfo: {type: Object, required: true, default: () => {} },
        treeListM: {type: Array, required: true, default: () => [] },
        treeListJ: {type: Array, required: true, default: () => [] },
        dialogSomaticName: {type: String, default: () => null },
        apiImg: {type: String, default: () => '' },
        mobile: Boolean
    },
    watch: {
        switchMe(val) {
            if(val) {
                this.items = this.treeListJ
                this.active = []
                this.selectedItem = null

                if(this.dialogSomaticName) {
                    const index = this.items.findIndex(f => f.name == this.dialogSomaticName);
                    this.selectedItem = index
                    this.active.push(this.treeListJ[index])
                }
                
                if(!this.dialogSomaticName && this.tapLevel1index) {
                    this.selectedItem = this.tapLevel1index
                    this.active.push(this.treeListJ[this.tapLevel1index])
                }

                // if(!this.dialogSomaticName) {
                //     this.tapList(this.items[0], 0);
                //     this.selectedItem = 0;
                // }
            }
            if(!val) {
                this.items = this.treeListM
                this.active = []
                this.selectedItem = null

                if(this.dialogSomaticName) {
                    const index = this.items.findIndex(f => f.name == this.dialogSomaticName);
                    this.selectedItem = index
                    this.active.push(this.treeListM[index])
                }

                if(!this.dialogSomaticName && this.tapLevel1index) {
                    this.selectedItem = this.tapLevel1index
                    this.active.push(this.treeListM[this.tapLevel1index])
                }

                // if(!this.dialogSomaticName) {
                //     this.tapList(this.items[0], 0);
                //     this.selectedItem = 0;
                // }
            }
        }
    },
    data: () => ({
        clientH: 688,
        tapLevel1index: null,
        urlImage: null,
        selectedItem: null,
        items: [],
        ageOnMonth: 1,
        active: [],
        activeName: null,
        switchMe: false
    }),
    methods: {
        dataIsNotFilled() {
            return this.active.length === 0 || (this.active[0] && this.active[0].propertyGroups.length == 0);
        },
        filterProperties(array, ageOnMonth) {
            let res = [];

            for (let i = 0; i < array.length; i++) {
                for (let j = 0; j < array[i].indicators.length; j++) {
                    let left = 0, right = array[i].indicators[j].propertyDataList.length - 1;
                
                    while(left <= right) {
                        let middle = Math.floor((left+right) / 2), currentIteration = array[i].indicators[j].propertyDataList[middle];

                        if (currentIteration.ageOnMonth < ageOnMonth) {
                            // console.log('currentIteration.ageOnMonth < ageOnMonth', currentIteration.ageOnMonth, left, middle, right);
                            left = middle + 1;
                        } else if (currentIteration.ageOnMonth > ageOnMonth) {
                            // console.log('currentIteration.ageOnMonth > ageOnMonth', currentIteration.ageOnMonth, left, middle, right);
                            right = middle - 1;
                        } else {
                            // console.log('else', currentIteration.ageOnMonth, left, middle, right);
                            left = middle
                            break;
                        }
                    }
                    

                    if(array[i].indicators[j].propertyDataList[left] && array[i].indicators[j].propertyDataList[left].ageOnMonth == ageOnMonth) {
                        res.push({
                            groupName: array[i].groupName,
                            name: array[i].indicators[j].indicatorName,
                            value: this.returnResult(array[i].indicators[j].propertyDataList[left])
                        })
                    } else if(array[i].indicators[j].propertyDataList[left-1]) {
                        res.push({
                            groupName: array[i].groupName,
                            name: array[i].indicators[j].indicatorName,
                            value: this.returnResult(array[i].indicators[j].propertyDataList[left-1])
                        })
                    } else {
                        // console.log(array[i].indicators[j].propertyDataList[left]);
                    }
                }
            }

            return res.reduce((group, product) => {
                const { groupName } = product;
                group[groupName] = group[groupName] ?? [];
                group[groupName].push(product);

                return group;
            }, {})
        },
        returnResult(obj) {
            // console.log('returnResult', obj);
            let res = '';

            if(obj.valueType == 1) {
                if(obj.maxValue) {
                    res = `${obj.measurement ? obj.measurement+': ' : ''}${obj.minValue}-${obj.maxValue}`
                } else {
                    res = `${obj.measurement ? obj.measurement+': От ' : ''}${obj.minValue}`
                }
            } else if(obj.valueType == 2) {
                res = obj.dictionaryValue ? obj.dictionaryValue : ''
            } else if(obj.valueType == 3){
                res = obj.valueList.length > 0 ? obj.valueList.reduce((a, b) => { return (a.dictionaryValue || a) + ', ' + b.dictionaryValue}) : ''
            }

            // console.log('returnResult', res);

            return typeof res == 'object' ? res.dictionaryValue : res
        },
        tapList(item, index) {
            this.active = [item]
            this.activeName = item.name

            if(!this.dialogSomaticName) {
                this.tapLevel1index = index
            } else {
                this.tapLevel1index = null
            }
        }
    },
    mounted() {
        // console.log('this.dialogSomaticName', this.dialogSomaticName);

        if (this.humanInfo.gender == 1) {
            this.switchMe = false
            this.items = this.treeListM
            
            if (this.dialogSomaticName) {
                const index = this.items.findIndex(f => f.name == this.dialogSomaticName);
                this.selectedItem = index
                this.active = [this.treeListM[index]]
            } else if (!this.mobile) {
                this.$nextTick(() => {
                    this.tapList(this.items[0], 0);
                    this.selectedItem = 0;
                })
            }
        }

        if (this.humanInfo.gender == 2) {
            this.switchMe = true
            this.items = this.treeListJ
            
            if (this.dialogSomaticName) {
                const index = this.items.findIndex(f => f.name == this.dialogSomaticName);
                this.selectedItem = index
                this.active = [this.treeListJ[index]]
            } else if (!this.mobile) {
                this.$nextTick(() => {
                    this.tapList(this.items[0], 0);
                    this.selectedItem = 0;
                })
            }
        }
    },
    created() {
        this.clientH = window.innerHeight;
    }
}
</script>

<style scoped>
ul li {
    font-size: 18px;
}
</style>

<style lang="scss">
.active {
    text-decoration: underline;
    text-decoration-style: double;
    text-decoration-color: #1976d2;
}
.fs-16 {
    font-size: 16px;
}
.custom-pink .v-input--selection-controls__input div {
  color: #ffa3e0!important;
  caret-color: #ffa3e0!important;
}
.custom-blue .v-input--selection-controls__input div {
  color: #1976d2!important;
  caret-color: #1976d2!important;
}

.colorIcon {
    color: #81b6e4f2!important;
}

@media screen and (max-width: 960px) {
    .btn-back {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 15px;
        font-weight: 500;
        padding: 5px 10px;
        background-color: #fff;
        border-radius: 12px;

        &.custom-blue {
            color: #1876D2;
            border: 2px solid #1876D2;
        }

        &.custom-pink {
            color: #FFA3E0;
            border: 2px solid #FFA3E0;
        }

        svg {
            margin-right: 7px;
        }
    }

    .slider-age .v-messages {
        min-height: 0;
    }
}
</style>